module.exports = __webpack_public_path__ + "5834.0c2ed50ef36d6c4882d0c564ccc25450.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5834.png
// module id = 633
// module chunks = 0